// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CircumstancesForm_form__MopWT {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.CircumstancesForm_inputs__5U-oa {
  display: flex;
  width: 100%;
  gap: 20px;
}

.CircumstancesForm_input__HuBh2 {
  width: 33.3333333333%;
}

.CircumstancesForm_textarea__5ifYr {
  height: 212px;
  margin: 28px 0;
}

.CircumstancesForm_contract__ZgruG {
  width: 100%;
  margin-bottom: 32px;
}

.CircumstancesForm_infoMessage__0omY3 {
  margin-bottom: 20px;
}

.CircumstancesForm_button__SS9MR {
  width: 200px;
}

.CircumstancesForm_cards__uOUIc {
  list-style-type: none;
  font-weight: 300;
  padding: 0;
  margin: 0;
}

@media screen and (max-width: 600px) {
  .CircumstancesForm_inputs__5U-oa {
    flex-direction: column;
    gap: 16px;
  }
  .CircumstancesForm_input__HuBh2 {
    width: 100%;
  }
  .CircumstancesForm_textarea__5ifYr {
    height: 140px;
    margin: 16px 0 20px;
  }
  .CircumstancesForm_button__SS9MR {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimApplication/CircumstancesForm/CircumstancesForm.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,WAAA;EACA,SAAA;AAIF;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,aAAA;EACA,cAAA;AAIF;;AADA;EACE,WAAA;EACA,mBAAA;AAIF;;AADA;EACE,mBAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AADA;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAIF;;AADA;EACE;IACE,sBAAA;IACA,SAAA;EAIF;EADA;IACE,WAAA;EAGF;EAAA;IACE,aAAA;IACA,mBAAA;EAEF;EACA;IACE,WAAA;EACF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.inputs {\n  display: flex;\n  width: 100%;\n  gap: 20px;\n}\n\n.input {\n  width: calc(100% / 3);\n}\n\n.textarea {\n  height: 212px;\n  margin: 28px 0;\n}\n\n.contract {\n  width: 100%;\n  margin-bottom: 32px;\n}\n\n.infoMessage {\n  margin-bottom: 20px;\n}\n\n.button {\n  width: 200px;\n}\n\n.cards{\n  list-style-type: none;\n  font-weight: 300;\n  padding: 0;\n  margin: 0;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .inputs {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .input {\n    width: 100%;\n  }\n\n  .textarea {\n    height: 140px;\n    margin: 16px 0 20px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"form": `CircumstancesForm_form__MopWT`,
	"inputs": `CircumstancesForm_inputs__5U-oa`,
	"input": `CircumstancesForm_input__HuBh2`,
	"textarea": `CircumstancesForm_textarea__5ifYr`,
	"contract": `CircumstancesForm_contract__ZgruG`,
	"infoMessage": `CircumstancesForm_infoMessage__0omY3`,
	"button": `CircumstancesForm_button__SS9MR`,
	"cards": `CircumstancesForm_cards__uOUIc`
};
export default ___CSS_LOADER_EXPORT___;
